import * as React from 'react';
import { Datagrid, ListProps, TextField, UrlField } from 'react-admin';
import { TranslateField } from '../components/TranslateField';
import TimeField from "../components/TimeField";

export const LiveTrainingDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="live-trainings-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<TextField source="title" label="TITLE"/>
			<TranslateField source="dayOfWeek" label="DAY"/>
			<TimeField source="startHour" label="START_HOUR"/>
			<TimeField source="endHour" label="END_HOUR"/>
			<UrlField source="link" label="LINK"/>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
